import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from '../configureStore';

// This currently allows inference, which breaks on any selectors which are javascript (unknown).
// This is actually desireable, but out of scope
// const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
const useAppSelector: any = useSelector;
export default useAppSelector;
